import { KEY_SHOW_HELP_TOOLTIP } from "./component";

export function closeMapHelpTooltip() {
  if (typeof window === "undefined") return;

  if (isMapHelpTooltipOpen()) {
    window.localStorage.setItem(KEY_SHOW_HELP_TOOLTIP, "false");
  }
}

export function isMapHelpTooltipOpen() {
  if (typeof window === "undefined") return false;

  const shouldOpen = window.localStorage.getItem(KEY_SHOW_HELP_TOOLTIP);
  return shouldOpen !== "false";
}
